<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form" :model="formData" ref="form" label-width="120px">
        <div class="row-title">基本信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单ID" prop="orderId">
              {{ formData.orderId }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提货单ID" prop="deliveryId">
              {{ formData.deliveryId }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="deliveryDate" label="提货日期">
              {{ formData.deliveryDate }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商" prop="supplierName">
              {{ formData.supplierName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应付金额" prop="yingfPrice">
              {{ formData.yingfPrice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="已付金额" prop="paidPrice">
              {{ formData.paidPrice }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="提货状态" prop="deliveryState">
              {{ deliveryStateMap.get(formData.deliveryState) }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload readonly v-model="formData.fileList" :maxSize="20"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="ygNotes">
              {{ formData.ygNotes }}
            </el-form-item>
          </el-col>
        </el-row>

        <div class="row-title">品种规格</div>
        <el-row>
          <el-table :data="formData.specList">
            <el-table-column fixed="left" :show-overflow-tooltip="true" min-width="200" prop="specName"
                             label="品种规格"></el-table-column>
            <el-table-column min-width="200" prop="specXh" label="规格单位"></el-table-column>
            <el-table-column min-width="150" prop="deliveryPlan" label="计划提货数量"></el-table-column>
            <el-table-column min-width="150" prop="deliveryQty" label="实际提货数量"></el-table-column>
            <el-table-column min-width="150" prop="vehicleKey" label="车牌号"></el-table-column>
            <el-table-column min-width="150" prop="vehicleGph" label="挂车号"></el-table-column>
            <el-table-column min-width="150" prop="driverName" label="司机姓名"></el-table-column>
            <el-table-column min-width="200" prop="driverKey" label="司机身份证"></el-table-column>
            <el-table-column min-width="150" prop="driverMobile" label="司机手机号"></el-table-column>
            <el-table-column min-width="220" show-overflow-tooltip prop="vehicleStartAddress"
                             label="提货库点"></el-table-column>
            <el-table-column min-width="220" show-overflow-tooltip prop="vehicleEndAddressName"
                             label="卸货库点"></el-table-column>
            <el-table-column min-width="380" prop="fileList" label="附件">
              <template v-slot="{ row }">
                <file-upload readonly v-model="row.fileList" :maxSize="20"></file-upload>
              </template>
            </el-table-column>
            <el-table-column min-width="180" fixed="right" label="操作">
              <template v-slot="{ row }">
                <el-button type="text" v-if="hasEdit && ['1', '2'].includes(formData.deliveryState)"
                           @click="showThDialog(row)">实际提货</el-button>
                <el-button type="text" v-if="hasAddRelation" @click="showPurchaseYxDialog(row)">关联提货单</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>

        <div class="row-title mt15">关联信息</div>
        <el-row>
          <el-col :span="24">
            <el-table size="mini" empty-text="暂无关联信息" stripe border :span-method="spanMethod" :data="purchaseYxList">
              <!-- <el-table-column min-width="120" label="云采点价单" prop="bidId"></el-table-column> -->
              <el-table-column min-width="120" label="云采提货单" prop="deliveryId"></el-table-column>
              <!-- <el-table-column min-width="120" label="云销点价单" prop="orderId"></el-table-column> -->
              <el-table-column min-width="230" label="云销提货单" prop="pickupNumber">
                <template v-slot="{ row }">
                  <el-button type="text" size="mini" @click="showDetail(row)">{{ row.pickupNumber }}</el-button>
                  <el-button v-if="row.pickupNumber" type="text" size="mini" @click.stop="handleCopyPickupNo(row.pickupNumber)">复制</el-button>
                </template>
              </el-table-column>
              <el-table-column min-width="120" label="关联数量" prop="pickupQuantity"></el-table-column>
              <el-table-column min-width="120" label="操作">
                <template v-slot="{ row }">
                  <el-button type="text" v-if="hasAddRelation" size="mini"
                             @click="removePurchaseYx(row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>

        <el-row class="mt15">
          <el-col :span="12">
            <el-form-item class="btn">
              <el-button type="primary" v-if="formData.deliveryState === '2' && hasSendOut"
                         @click="sendOut2">发货</el-button>
              <el-button v-if="hasApproval && formData.deliveryState === '1'" type="primary"
                         @click="approve">审批</el-button>
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

    <PurchaseDeliveryDialog :dataInfo="formData" v-if="approveVisible" @closeDlg="approveVisible = false"
                            @successSave="loadData" :showDlg.sync="approveVisible"></PurchaseDeliveryDialog>

    <el-dialog title="修改实际提货数量" class="global-dialog" :visible.sync="showThVisible" width="600px">
      <div class="dlg-content">
        <el-form class="global-form" style="padding:30px 40px 20px 20px" :model="fhFormData" ref="fhForm"
                 :rules="fhRules" label-width="140px">
          <el-row>
            <el-col :span="24">
              <el-form-item prop="deliveryState" label="规格">
                {{ fhFormData.specName }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="deliveryState" label="计划提货数量">
                {{ fhFormData.deliveryPlan }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="deliveryQty" label="实际提货数量">
                <el-input v-model="fhFormData.deliveryQty" placeholder="请输入实际提货数量"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="fileList" label="附件">
                <file-upload v-model="fhFormData.fileList" :maxSize="20"></file-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showThVisible = false">取 消</el-button>
        <el-button @click="sendOut" type="primary">保 存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="关联采购提货" class="global-dialog" :visible.sync="showPurchaseYxVisible" width="800px">
      <div class="dlg-content">
        <el-form class="global-form" label-position="top" :show-message="false" inline-message
                 style="padding:20px 20px 20px 20px" :model="formData5" :rules="rules5" ref="form5" label-width="120px">
          <el-button class="mb10" v-if="!isEditOrder && hasAddRelation" type="primary"
                     @click="addPurchaseYx(null)">添加云销关联</el-button>
          <el-table class="gl-list" :data="formData5.purchaseYxList" style="width: 100%">
            <!-- <el-table-column prop="orderId" label="云销点价单">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`purchaseYxList.${$index}.orderId`"
                  :rules="[{ required: true, message: '请选择云销点价单' }]">
                  <el-select v-model="row.orderId" :disabled="isEditOrder" placeholder="请选择云销点价单"
                    @change="val => loadPurchaseData(val, row)">
                    <el-option v-for="item in formatOrderList" :key="item.orderId" :label="item.specName"
                      :value="item.orderId"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column> -->
            <el-table-column prop="deliveryId" label="云销提货单">
              <template v-slot="{ row }">
                <el-form-item :rules="[{ required: true, message: '请选择云销提货单' }]">
                  <el-select v-model="row.pickupId" :filterable="true" placeholder="请选择云销提货单"
                             @change="val => onChangeDelivery(val, row)">
                    <el-option v-for="item in deliveryOrderList" :key="item.pickupId" :label="item.pickupNumber"
                               :value="item.pickupId"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="formatPickupQuantity" label="实提数量"></el-table-column>
            <el-table-column prop="pickupQuantity" label="采购数量">
              <template v-slot="{ row, $index }">
                <el-form-item :prop="`purchaseYxList.${$index}.pickupQuantity`"
                              :rules="[{ required: true, message: '请输入采购数量' }]">
                  <el-input :disabled="!row.edit && isEditOrder" v-model="row.pickupQuantity"
                            placeholder="请输入采购数量"></el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column width="120" label="操作">
              <template v-slot="{ row, $index }">
                <el-button v-if="isEditOrder && !row.edit" type="text" @click="row.edit = true">修改数量</el-button>
                <el-button v-if="isEditOrder && row.edit" type="text" @click="submitPurchaseYx(row)">保存数量</el-button>
                <el-button class="del-btn" v-if="hasDelRelation" type="text"
                           @click="removePurchaseYx2($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
      <span v-if="!isEditOrder" slot="footer" class="dialog-footer">
        <el-button @click="showPurchaseYxVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitPurchaseYx">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { deliveryState } from '@/utils/dict'
import PurchaseDeliveryDialog from '@/views/purchaseDelivery/PurchaseDeliveryDialog.vue'
import { validNumber2 } from '@/utils/validator'
import { deepClone, copyText } from '../../utils/utils'

export default {
  name: 'purchaseDeliveryAdd',
  components: {
    PurchaseDeliveryDialog
  },
  data() {
    return {
      showThVisible: false,
      showPurchaseYxVisible: false,
      deliveryStateMap: deliveryState,
      approveVisible: false,
      specId: '',
      currentOrderId: '',
      warehouseId: '',
      isEditOrder: false,
      deliveryOrderList: [],
      formData: {
        paidPrice: '', // 已付金额
        yingfPrice: '', // 应付金额
        orderId: '', // 标书/订单ID
        deliveryId: '', // 提货ID
        orderTitle: '', // 合同标题
        orderNum: '', // 合同编号
        purchaser: '', // 采购方
        supplierName: '', // 供应商名称
        supplierMobile: '', // 供应商手机号
        deliveryDate: '', // 提货日期
        deliveryState: '', // 发货状态1待审核2待发货3已发货4已驳回
        deliveryPrice: '', // 结算单价
        isDel: 0, // 是否删除，1为删除，0为未删除
        createUserId: '', // 创建人
        ctime: '', // 创建时间
        ygNotes: '', // 备注
        vehicleFile: '', // 提货委托单
        fileList: [], // 附件列表
        specList: [] // 车辆列表
      },
      fhFormData: {
        id: '', // 记录id
        specName: '',
        deliveryPlan: '', // 计划提货数量
        deliveryId: '', // 提货ID
        deliveryQty: '', // 实际提货数量
        fileList: [] // 附件列表
      },
      purchaseYxList: [], // 采购确认列表
      fhRules: {
        deliveryQty: [
          { required: true, message: '请输入实际提货数量' },
          { pattern: validNumber2, message: '提货数量格式错误' }
        ]
      },
      formData5: {
        purchaseYxList: []
      },
      rules5: {
        purchaseYxList: [
          { required: true, message: '请添加关联提货单' }
        ]
      }
    }
  },
  created() {
    if (this.deliveryId) {
      this.loadData()
      this.loadPurchaseYxList()
    }
  },
  computed: {
    hasAddRelation() {
      return this.buttonList.includes('addrelation')
    },
    hasDelRelation() {
      return this.buttonList.includes('delrelation')
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasApproval() {
      return this.buttonList.includes('approval')
    },
    hasSendOut() {
      return this.buttonList.includes('sendout')
    },
    deliveryId() {
      return this.$route.query.deliveryId
    }
  },
  methods: {
    async handleCopyPickupNo(text) {
      const success = await copyText(text)
      if (success) {
        this.$message.success('复制成功')
      } else {
        this.$message.error('复制失败，请手动复制')
      }
    },
    onChangeDelivery(val, row) {
      const data = this.deliveryOrderList.find(item => item.pickupId === val)
      row.orderId = data.orderId
      row.formatPickupQuantity = data.pickupQuantity
    },
    removePurchaseYx2(index) {
      this.formData5.purchaseYxList.splice(index, 1)
    },
    removePurchaseYx(id) {
      this.$confirm('确认删除关联吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = this.purchaseYxList.find(item => item.id === id)
        if (data.id) {
          this.$axios.post(this.$apis.purchaseYx.deleteDataPurchaseYx, {
            id: data.id
          }).then(res => {
            this.loadPurchaseYxList()
          })
        }
      })
    },
    showPurchaseYxDialog(row) {
      this.warehouseId = row.vehicleEndAddress
      this.specId = row.specId
      this.isEditOrder = false
      this.formData5.purchaseYxList = []
      this.addPurchaseYx(row.orderId)
      this.loadPurchaseYxListByWarehouseId()
      this.showPurchaseYxVisible = true
      this.currentOrderId = row.orderId
    },
    addPurchaseYx(orderId) {
      this.formData5.purchaseYxList.push({
        deliveryId: this.deliveryId, // 云采提货单id
        bidId: orderId || this.currentOrderId, // 云采点价单id
        pickupId: '', // 云销提货单id
        orderId: '', // 云销点价单id
        pickupQuantity: '', // 关联数量
        edit: false
      })
    },
    loadPurchaseYxListByWarehouseId() {
      this.$axios.get(this.$apis.deliveryOrder.selectYxPickupOrderByPageV2, {
        warehouseId: this.warehouseId,
        specId: this.specId,
        ycState: '1',
        isVehicle: '2'
      }).then(res => {
        this.deliveryOrderList = res.list || []
      })
    },
    submitPurchaseYx(row) {
      let url = this.$apis.purchaseYx.insertAllPurchaseYx
      let formData = deepClone(this.formData5.purchaseYxList)
      if (this.isEditOrder) {
        url = this.$apis.purchaseYx.updatePurchaseYx
        formData = deepClone(row)
        delete formData.edit
        delete formData.formatPickupQuantity
      } else {
        formData.forEach(item => {
          delete item.edit
          delete item.formatPickupQuantity
        })
      }
      this.$refs.form5.validate().then(() => {
        this.$axios.post(url, formData).then(async res => {
          await this.loadData()
          this.loadPurchaseYxList()
          this.showPurchaseYxVisible = false
        })
      })
    },
    loadPurchaseYxList() {
      this.$axios.get(this.$apis.purchaseYx.selectPurchaseYxByList, {
        deliveryId: this.deliveryId
      }).then(res => {
        this.purchaseYxList = res.list || []
      })
    },
    approve() {
      this.approveVisible = true
    },
    showDetail(row) {
      this.$router.push(`/deliveryOrder/detail?pickupId=${row.pickupId}`)
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      // 需要合并的列下标（根据你实际列调整）
      const mergeColumns = [0] // 订单号、商品名称 合并
      if (mergeColumns.includes(columnIndex)) {
        if (rowIndex === 0) {
          return {
            rowspan: this.purchaseYxList.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
      return {
        rowspan: 1,
        colspan: 1
      }
    },
    loadData() {
      this.$axios.get(this.$apis.purchaseDelivery.selectYcDeliveryByDeliveryId, {
        params: { deliveryId: this.deliveryId }
      }).then(res => {
        res.fileList = res.fileList || []
        res.specList.forEach(item => {
          item.fileList = item.fileList || []
        })
        this.formData = res || {}
      })
    },
    sendOut2() {
      if (!this.formData.specList.every(item => item.deliveryQty > 0)) {
        this.$message.error('请修改实际提货数量')
        return
      }
      this.$confirm('确定发货吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.purchaseDelivery.approveYcDelivery, {
          deliveryId: this.deliveryId,
          deliveryState: '3'
        }).then(() => {
          this.$router.back()
        })
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.purchaseDelivery.insertYcDelivery
        if (this.deliveryId) {
          url = this.$apis.purchaseDelivery.updateYcDelivery
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    },
    showThDialog(item) {
      this.fhFormData.id = item.id
      this.fhFormData.specName = item.specName
      this.fhFormData.deliveryPlan = item.deliveryPlan || ''
      this.fhFormData.deliveryId = this.deliveryId
      this.fhFormData.deliveryQty = item.deliveryQty || ''
      this.fhFormData.fileList = []
      this.showThVisible = true
    },
    sendOut() {
      this.$refs.fhForm.validate().then(() => {
        const formData = deepClone(this.fhFormData)
        delete formData.specName
        delete formData.deliveryPlan
        this.$axios.post(this.$apis.purchaseDelivery.updateYcDeliverySpec, formData).then(() => {
          this.showThVisible = false
          this.loadData()
        })
      })
    }
  }
}
</script>

<style lang="scss">
.row-title {
  font-size: 14px;
  position: relative;
  padding-left: 14px;
  margin-bottom: 20px;

  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    width: 3px;
    background-color: #36f;
    border-radius: 2px;
    transform: translateY(-50%);
  }
}

.order-select {
  .el-select-dropdown__item {
    height: 68px !important;
    line-height: 68px !important;
  }
}

.order-line {
  display: flex;
  flex-direction: column;
  height: 68px !important;
  line-height: 68px !important;

  .line-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;

    span {
      line-height: 34px;
      font-size: 13px;
    }
  }
}
</style>

<style scoped lang='scss'>
.gl-list {
  .el-form-item {
    margin-bottom: 0 !important;
  }
}

.line-tips {
  display: flex;
  align-items: center;
  position: relative;
  height: 30px;
  padding-left: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 4px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    height: 20px;
    width: 3px;
    background: #409eff;
  }

  span {
    font-size: 14px;
  }
}

.tips {
  font-size: 12px;
  color: #AAA;
}

::v-deep .el-form {
  .el-input-number,
  .el-select,
  .el-input,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
